export default {
  methods: {
    async whenValid(callback) {
      if (this.$validator && (await this.$validator.validateAll())) {
        callback();
      }
    },
  },
};
